export default function AboutSection() {
  return (
    <section id="about" className="w-full py-20 md:py-28 bg-background-100">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          <div className="w-full lg:w-1/2">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20Japanese%20office%20interior%20with%20warm%20wooden%20desk%20and%20minimalist%20design%2C%20large%20windows%20with%20natural%20sunlight%2C%20professional%20yet%20inviting%20atmosphere%2C%20clean%20aesthetic%20with%20subtle%20amber%20accent%20details%2C%20Yokohama%20city%20view%20through%20window%2C%20editorial%20photography%20style%2C%20soft%20shadows%2C%20warm%20neutral%20tones&width=800&height=600&seq=dream-about-2026&orientation=landscape"
                alt="株式会社Ｄｒｅａｍ オフィス"
                className="w-full rounded-lg object-cover"
              />
              <div className="absolute -bottom-4 -right-4 w-full h-full rounded-lg border-2 border-primary-300/50 -z-10" />
            </div>
          </div>

          <div className="w-full lg:w-1/2">
            <p className="text-primary-600 text-sm font-medium tracking-widest mb-3">ABOUT US</p>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-5">
              私たちについて
            </h2>
            <p className="text-foreground-700 text-sm md:text-base leading-relaxed mb-6">
              株式会社Ｄｒｅａｍは、横浜を拠点に企業の営業支援とコンサルティングを軸とした
              ビジネスソリューションを展開しています。
            </p>
            <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-8">
              営業代行、販売代行からシステム開発まで、幅広いニーズにワンストップで対応。
              お客様のビジネス成長に真摯に向き合い、課題に応じた支援を丁寧にご提案しています。
              これからも「信頼されるパートナー」として、全力でサポートしてまいります。
            </p>

            <div className="grid grid-cols-3 gap-4 mb-8">
              <div className="text-center p-4 rounded-lg bg-background-50 border border-background-200/70">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-1">伴走</div>
                <p className="text-xs text-foreground-500">法人向け支援</p>
              </div>
              <div className="text-center p-4 rounded-lg bg-background-50 border border-background-200/70">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-600 mb-1">柔軟</div>
                <p className="text-xs text-foreground-500">状況に応じた提案</p>
              </div>
              <div className="text-center p-4 rounded-lg bg-background-50 border border-background-200/70">
                <div className="text-2xl md:text-3xl font-heading font-bold text-primary-600 mb-1">誠実</div>
                <p className="text-xs text-foreground-500">丁寧な対応</p>
              </div>
            </div>

            <div className="flex flex-col gap-4 text-sm text-foreground-600">
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 flex-shrink-0">
                  <i className="ri-map-pin-line" />
                </div>
                <span>神奈川県横浜市西区北幸２丁目１０番４８号むつみビル３階</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-8 h-8 flex items-center justify-center rounded-full bg-primary-50 text-primary-600 flex-shrink-0">
                  <i className="ri-user-line" />
                </div>
                <span>代表取締役　笹川俊</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
